<template>
    <div>
        <b-row>
            <b-col>
                <h3 class="text-primary">
                    <span class="fa fa-user"></span> {{ role.label }}
                </h3>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <b-row>
                        <b-col>
                            <b-button size="sm" variant="primary" @click="voltar" :disabled="loading">
                                <i class="fas fa-arrow-left"></i> Voltar
                            </b-button>

                            <b-button size="sm" variant="primary" @click="adicionar" :disabled="loading">
                                <i class="fas fa-plus"></i> Adicionar Regra
                            </b-button>
                        </b-col>

                        <b-col class="text-right">
                            <b-button size="sm" variant="success" @click="salvar" :disabled="loading">
                                <i class="fas fa-save"></i> Salvar
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            <h3>Permissões do grupo</h3>
                        </b-col>
                    </b-row>
                    <b-row v-if="!loading" class="ml-3">
                        <b-col class="col-md-4" v-for="perm in persCadastroOrdenado" :key="perm.id">
                            <b-form-checkbox v-model="perm.checked" v-b-tooltip.hover.lefttop="perm.name">
                                {{ perm.label }}
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row v-else class="text-primary">
                        <b-col class="text-center">
                            <b>
                                <b-spinner label="Spinning" /> Carregando Permissões...
                            </b>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-modal title="Adicionar Regra" v-model="modalRegra">
            <b-form-group label="Nome" description="Exemplo: listar_regras">
                <b-form-input v-model="regra.name" />
            </b-form-group>

            <b-form-group label="Label" description="Exemplo: Listar Regras">
                <b-form-input v-model="regra.label" />
            </b-form-group>

            <template #modal-footer>
                <b-button size="sm" variant="success" @click="adicionarRegra" :disabled="loading">
                    Salvar
                </b-button>
                <b-button size="sm" variant="secondary" @click="modalRegra = false" :disabled="loading">
                    Fechar
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'permissoes',

    data() {
        return {
            regra: {
                label: '',
                name: ''
            },
            modalRegra: false,
            loading: false,

            role: JSON.parse(document.getElementById('role').value),
            permissions: JSON.parse(document.getElementById('permissions').value),
            pers_cadastro: JSON.parse(document.getElementById('pers_cadastro').value)
        }
    },

    mounted() {
        this.setPermissions();
    },

    computed: {
        persCadastroOrdenado() {
            return [...this.pers_cadastro].sort((a, b) =>
                a.label.localeCompare(b.label, 'pt-BR')
            );
        }
    },

    methods: {
        voltar() {
            window.location.href = '/adm/users/grupos';
        },

        adicionar() {
            this.modalRegra = true;
        },

        adicionarRegra() {
            if (!this.regra.name || !this.regra.label) {
                return this.$swal.fire({
                    title: 'Atenção!',
                    text: 'O nome e o label devem ser preenchidos',
                    icon: 'error'
                });
            }

            this.loading = true;

            axios.post('/adm/users/acessos/regra', this.regra)
                .then(() => {
                    location.reload();
                })
                .catch(() => {
                    this.$swal.fire({
                        title: 'Erro!',
                        text: 'Já existe uma regra com este nome',
                        icon: 'error'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        salvar() {
            this.loading = true;

            axios.post('/adm/users/acessos/permissoes', {
                permissions: this.pers_cadastro,
                role: this.role
            })
                .then(() => {
                    this.$swal.fire({
                        title: 'Sucesso!',
                        text: 'Permissões alteradas com sucesso!',
                        icon: 'success'
                    });
                })
                .catch(() => {
                    this.$swal.fire({
                        title: 'Erro!',
                        text: 'Erro ao alterar permissões',
                        icon: 'error'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        setPermissions() {
            this.loading = true;

            this.pers_cadastro = this.pers_cadastro.map(perm => {
                perm.checked = !!this.permissions.find(p => p.id === perm.id);
                return perm;
            });

            this.loading = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/util/Permissoes.vue